/* eslint-disable import/order */
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { featuresResource } from '@jira/router-resources__service-project-features/src/featuresResource.tsx';
import { projectSettingsServicedeskItsmFeaturesRoute } from '@jira/router-routes__project-settings-product-routes-service-desk-routes/src/projectSettingsServicedeskItsmFeaturesRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import ServiceDeskItsmFeatures, {
	LazyProjectSettingsServiceDeskItsmFeatures,
} from './ui/service-desk-itsm-features/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const projectSettingsServicedeskItsmFeaturesRouteEntry: Route = createEntry(
	projectSettingsServicedeskItsmFeaturesRoute,
	() => ({
		group: 'project-settings-servicedesk',
		ufoName: 'jsm-features-settings',
		// eslint-disable-next-line no-restricted-syntax
		component: ServiceDeskItsmFeatures,
		layout: serviceProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},

		resources: [
			...getServiceDeskSettingsResources(),
			featuresResource,
			getConsolidationStateResource(),
		],

		forPaint: [LazyAtlassianNavigation, LazyProjectSettingsServiceDeskItsmFeatures],
		perfMetricKey: 'jsm-features-settings',

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
